let React              = require("react");  
let Utility            = require("../../util/Utilities.js");  
let CircuitsUtil       = require("../../util/CircuitsUtil.js");
let TooltipCard        = require("./Tooltip.jsx");
let LoadingPlaceholder = require("./LoadingPlaceholder.jsx");
let ImportUtil         = require("./../../util/ImportUtil.js");

class CardDetails extends React.Component {
    constructor() {
        super();

        this.state = { 
            isLoading: false,
        }
        
        this.timer = {};
    }

    componentDidMount(){
        const { handleError, resource, isTrash } = this.props;
        
        if(resource.type !== "3dmodel" || isTrash){ return null};
        
        if(!this.props.isPublicFacing && !CircuitsUtil.modelTranslationSuccess(resource) && !CircuitsUtil.modelTranslationFailed(resource)){
            this.setState({isLoading: true})
            ImportUtil.getStatusModel(handleError, resource.id, resource.name, this.timer)
                .then(info => {
                  this.props.reloadResource((asset) => {
                    console.log(asset);
                    this.setState({isLoading: false})
                  });
                  this.props.uploadFinished();
                })
                .catch(error => this.props.reloadResource(() => this.setState({isLoading: false})))
        }
    }
    
    componentWillUnmount() {
        if(this.timer.timeout) clearTimeout(this.timer.timeout);
    }

    checkStatus(){
        const { resource } = this.props;
        
         if(resource.type === "3dmodel"){
           if(CircuitsUtil.modelTranslationWarning(resource)){
             // if(CircuitsUtil.modelHasXref(resource)){
             //   return {
             //       type:  "warn",
             //       info: `OBJ failed - external references. This model will be fixed in the future. ID ${resource.id}`
             //   }
             // } else {
               return {
                   type:  "warn",
                   info: `OBJ failed - insufficient geometry.  ID ${resource.id}`
               }
             //}

           } else if(CircuitsUtil.modelTranslationFailed(resource)){
             return {
                 type:  "bad",
                 info: `This model could not be translated, it might be corrupt. ID ${resource.id}.`
             }
           } else {
             return {
                 type:  "done"
             }
           }

        } else if(resource.type === "library"){
            if(CircuitsUtil.getStatusLibrary(resource.save_points) !== "failed"){
                return {type: "done"};
            } else {
                 return {
                    type: "bad",
                    info: `There was a problem uploading your library. If this problem persists, please contact support with reference ID ${resource.id}.`
                };
                
            }
           
        } else {
            return {type: "done"};
        }

        
    }

	render(){
        const { 
            Action,
            resource, 
            getButtons, 
            loginRequired, 
            layout, 
            InfoOverlay, 
            children, 
            toggleProperties, 
            deleted, 
            Buttons,
            showOwner,
            isTrash,
            isPublicFacing = false,
        } = this.props;

        const properties = resource.properties || {};
        const status = this.checkStatus();

		return <React.Fragment>
            <div className="card__item card__details">
                <div className="card__details__group">
                    <div className="card__details__name">
                    {<Action Content={props=><p className={`link ${props.noLink? "noLink": "" }`}>{resource.name}</p>}/>}
                    </div>
                    {showOwner && <div className="card__details__owner">by {resource.hub_name}</div>}
                </div>

                { InfoOverlay && 
                    <div className="card__details__icon" onMouseEnter={toggleProperties} onMouseLeave={toggleProperties}></div> }
            </div>
            
            { children ? children({layout, properties}):  
                                <div className="card__item card__summary">
                                    {Utility.formatDescription(resource.summary, layout)}
                                </div>}

            <div className="info__status">
                {!this.state.isLoading && !isPublicFacing &&
                    <TooltipCard key={resource.id} private={resource.private} {...status} />}
            </div>

            <div className="card__item card__date">
                {Utility.formatDateString(resource.updated_at)}
            </div>
            <div className="card__item card__info">
                {this.state.isLoading && <LoadingPlaceholder getButtons={()=>getButtons(Buttons, "list", true)}/> }
                {!this.state.isLoading &&  loginRequired && layout == "list" && !deleted &&
                    getButtons(Buttons, "list") }
            </div>
        </React.Fragment>
	}
}

module.exports = CardDetails;
